export default __webpack_public_path__ + "static/media/J.95358eaf.svg";